import { MutationTuple, gql, useMutation } from '@apollo/client';

import {
  useEditPromotion_CreateAdMutation,
  useEditPromotion_CreateAdMutationVariables,
} from './graphql-types/useEditPromotion_CreateAdMutation';
import {
  useEditPromotion_UpdateAdMutation,
  useEditPromotion_UpdateAdMutationVariables,
} from './graphql-types/useEditPromotion_UpdateAdMutation';

const AD_FRAGMENT = gql`
  fragment useEditPromotion_AdFragment on Ad {
    _id
    title
    body
    registerInterestTitle
    callToAction
    url
    adImage {
      _id
      imageProxy(input: { w: 560 })
    }
    published
    organization {
      _id
      sponsorship {
        organizationOnboardingChecklistState {
          promotionAdded
        }
        ad(input: { filters: { includeUnpublished: true } }) {
          _id
        }
        sponsorPageAd(input: { filters: { includeUnpublished: true } }) {
          _id
        }
      }
    }
  }
`;

const UPDATE_AD = gql`
  mutation useEditPromotion_UpdateAdMutation($input: UpdateAdInput!) {
    updateAd(input: $input) {
      data {
        _id
        ...useEditPromotion_AdFragment
      }
    }
  }
  ${AD_FRAGMENT}
`;

const CREATE_AD = gql`
  mutation useEditPromotion_CreateAdMutation($input: CreateAdInput!) {
    createAd(input: $input) {
      data {
        _id
        ...useEditPromotion_AdFragment
      }
    }
  }
  ${AD_FRAGMENT}
`;

export const useEditPromotion = (): {
  update: MutationTuple<
    useEditPromotion_UpdateAdMutation,
    useEditPromotion_UpdateAdMutationVariables
  >;
  create: MutationTuple<
    useEditPromotion_CreateAdMutation,
    useEditPromotion_CreateAdMutationVariables
  >;
} => {
  const update = useMutation<
    useEditPromotion_UpdateAdMutation,
    useEditPromotion_UpdateAdMutationVariables
  >(UPDATE_AD);

  const create = useMutation<
    useEditPromotion_CreateAdMutation,
    useEditPromotion_CreateAdMutationVariables
  >(CREATE_AD);

  return {
    update,
    create,
  };
};

useEditPromotion.adFragment = AD_FRAGMENT;
